import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 flex items-center justify-center p-4">
      <Card className="bg-white/10 backdrop-blur-sm border-white/20 max-w-md w-full">
        <CardHeader className="text-center">
          <XCircle className="w-16 h-16 text-amber-400 mx-auto mb-4" />
          <CardTitle className="text-white text-2xl">Payment Cancelled</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-gray-300">
            Your payment was cancelled. No charges were made.
          </p>
          <p className="text-gray-400 text-sm">
            You can purchase credits anytime from the dashboard.
          </p>
          
          <div className="flex flex-col gap-2 mt-4">
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-purple-600 hover:bg-purple-700"
              data-testid="return-to-dashboard-btn"
            >
              Return to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
